import { render, staticRenderFns } from "./number-card-wrapper.vue?vue&type=template&id=36ec1fd0&scoped=true&"
import script from "./number-card-wrapper.vue?vue&type=script&lang=js&"
export * from "./number-card-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./number-card-wrapper.vue?vue&type=style&index=0&id=36ec1fd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ec1fd0",
  null
  
)

export default component.exports